/**
 * @generated SignedSource<<04be969fd71ae19d7c2d893be23df7c2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type HomeHeaderViewQuery$variables = {
  goalUpdatesCreatedAfter?: string | null;
  goalUpdatesCreatedBefore?: string | null;
  includeReadingModeGoalUpdates: boolean;
  includeReadingModeProjectUpdates: boolean;
  isHomeHeaderEnabled: boolean;
  loadWritingModeGoalsQuery: boolean;
  loadWritingModeProjectsQuery: boolean;
  pendingUpdateGoalsTqlQuery: string;
  pendingUpdateProjectsTqlQuery: string;
  projectUpdatesCreatedAfter?: string | null;
  projectUpdatesCreatedBefore?: string | null;
  workspaceUUID?: string | null;
};
export type HomeHeaderViewQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"HeaderUpdateButtons">;
};
export type HomeHeaderViewQuery = {
  response: HomeHeaderViewQuery$data;
  variables: HomeHeaderViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "goalUpdatesCreatedAfter"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "goalUpdatesCreatedBefore"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeReadingModeGoalUpdates"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeReadingModeProjectUpdates"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isHomeHeaderEnabled"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "loadWritingModeGoalsQuery"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "loadWritingModeProjectsQuery"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pendingUpdateGoalsTqlQuery"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pendingUpdateProjectsTqlQuery"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectUpdatesCreatedAfter"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectUpdatesCreatedBefore"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workspaceUUID"
},
v12 = {
  "kind": "Variable",
  "name": "workspaceUUID",
  "variableName": "workspaceUUID"
},
v13 = {
  "kind": "Literal",
  "name": "first",
  "value": 50
},
v14 = [
  "LATEST_UPDATE_DATE_ASC",
  "NAME_ASC"
],
v15 = {
  "kind": "Variable",
  "name": "workspaceUuid",
  "variableName": "workspaceUUID"
},
v16 = {
  "kind": "ScalarField",
  "name": "id"
},
v17 = [
  {
    "kind": "ScalarField",
    "name": "creationDate"
  },
  (v16/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/)
    ],
    "kind": "Fragment",
    "name": "HomeHeaderViewQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "goalUpdatesCreatedAfter",
            "variableName": "goalUpdatesCreatedAfter"
          },
          {
            "kind": "Variable",
            "name": "goalUpdatesCreatedBefore",
            "variableName": "goalUpdatesCreatedBefore"
          },
          {
            "kind": "Variable",
            "name": "includeReadingModeGoalUpdates",
            "variableName": "includeReadingModeGoalUpdates"
          },
          {
            "kind": "Variable",
            "name": "includeReadingModeProjectUpdates",
            "variableName": "includeReadingModeProjectUpdates"
          },
          {
            "kind": "Variable",
            "name": "loadWritingModeGoalsQuery",
            "variableName": "loadWritingModeGoalsQuery"
          },
          {
            "kind": "Variable",
            "name": "loadWritingModeProjectsQuery",
            "variableName": "loadWritingModeProjectsQuery"
          },
          {
            "kind": "Variable",
            "name": "pendingUpdateGoalsTqlQuery",
            "variableName": "pendingUpdateGoalsTqlQuery"
          },
          {
            "kind": "Variable",
            "name": "pendingUpdateProjectsTqlQuery",
            "variableName": "pendingUpdateProjectsTqlQuery"
          },
          {
            "kind": "Variable",
            "name": "projectUpdatesCreatedAfter",
            "variableName": "projectUpdatesCreatedAfter"
          },
          {
            "kind": "Variable",
            "name": "projectUpdatesCreatedBefore",
            "variableName": "projectUpdatesCreatedBefore"
          },
          (v12/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "HeaderUpdateButtons"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v11/*: any*/),
      (v4/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v10/*: any*/),
      (v9/*: any*/),
      (v8/*: any*/),
      (v7/*: any*/),
      (v6/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Operation",
    "name": "HomeHeaderViewQuery",
    "selections": [
      {
        "condition": "isHomeHeaderEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "condition": "loadWritingModeProjectsQuery",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "pendingProjectUpdates",
                "args": [
                  (v13/*: any*/),
                  {
                    "kind": "Variable",
                    "name": "q",
                    "variableName": "pendingUpdateProjectsTqlQuery"
                  },
                  {
                    "kind": "Literal",
                    "name": "sort",
                    "value": (v14/*: any*/)
                  },
                  (v15/*: any*/)
                ],
                "concreteType": "ProjectConnection",
                "kind": "LinkedField",
                "name": "projectTql",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "ProjectEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "Project",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "ProjectUpdate",
                            "kind": "LinkedField",
                            "name": "latestUserUpdate",
                            "plural": false,
                            "selections": (v17/*: any*/)
                          },
                          (v16/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "condition": "loadWritingModeGoalsQuery",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "pendingGoalUpdates",
                "args": [
                  (v13/*: any*/),
                  {
                    "kind": "Variable",
                    "name": "q",
                    "variableName": "pendingUpdateGoalsTqlQuery"
                  },
                  {
                    "kind": "Literal",
                    "name": "sorts",
                    "value": (v14/*: any*/)
                  },
                  (v15/*: any*/)
                ],
                "concreteType": "GoalConnection",
                "kind": "LinkedField",
                "name": "goalTql",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "GoalEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "Goal",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "GoalUpdate",
                            "kind": "LinkedField",
                            "name": "latestUserUpdate",
                            "plural": false,
                            "selections": (v17/*: any*/)
                          },
                          (v16/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "condition": "includeReadingModeProjectUpdates",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "projectCount",
                "args": [
                  {
                    "kind": "Variable",
                    "name": "createdAfter",
                    "variableName": "projectUpdatesCreatedAfter"
                  },
                  {
                    "kind": "Variable",
                    "name": "createdBefore",
                    "variableName": "projectUpdatesCreatedBefore"
                  },
                  (v12/*: any*/)
                ],
                "kind": "ScalarField",
                "name": "allWatchedProjectUpdatesCount"
              }
            ]
          },
          {
            "condition": "includeReadingModeGoalUpdates",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "goalCount",
                "args": [
                  {
                    "kind": "Variable",
                    "name": "createdAfter",
                    "variableName": "goalUpdatesCreatedAfter"
                  },
                  {
                    "kind": "Variable",
                    "name": "createdBefore",
                    "variableName": "goalUpdatesCreatedBefore"
                  },
                  (v12/*: any*/)
                ],
                "kind": "ScalarField",
                "name": "allWatchedGoalUpdatesCount"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "8ede9ab32b2fdf98c4536898c3014ba0",
    "id": null,
    "metadata": {},
    "name": "HomeHeaderViewQuery",
    "operationKind": "query",
    "text": "query HomeHeaderViewQuery(\n  $workspaceUUID: UUID\n  $isHomeHeaderEnabled: Boolean!\n  $goalUpdatesCreatedAfter: DateTime\n  $goalUpdatesCreatedBefore: DateTime\n  $includeReadingModeGoalUpdates: Boolean!\n  $includeReadingModeProjectUpdates: Boolean!\n  $projectUpdatesCreatedBefore: DateTime\n  $projectUpdatesCreatedAfter: DateTime\n  $pendingUpdateProjectsTqlQuery: String!\n  $pendingUpdateGoalsTqlQuery: String!\n  $loadWritingModeProjectsQuery: Boolean!\n  $loadWritingModeGoalsQuery: Boolean!\n) {\n  ...HeaderUpdateButtons_2r8fyP\n}\n\nfragment HeaderUpdateButtons_2r8fyP on Query {\n  ...WritingModeButton_data_48lAvG @include(if: $isHomeHeaderEnabled)\n  ...ReadingModeButton_data_3Cmsau @include(if: $isHomeHeaderEnabled)\n}\n\nfragment ReadingModeButton_data_3Cmsau on Query {\n  projectCount: allWatchedProjectUpdatesCount(createdBefore: $projectUpdatesCreatedBefore, createdAfter: $projectUpdatesCreatedAfter, workspaceUUID: $workspaceUUID) @include(if: $includeReadingModeProjectUpdates)\n  goalCount: allWatchedGoalUpdatesCount(workspaceUUID: $workspaceUUID, createdBefore: $goalUpdatesCreatedBefore, createdAfter: $goalUpdatesCreatedAfter) @include(if: $includeReadingModeGoalUpdates)\n}\n\nfragment WritingModeButton_data_48lAvG on Query {\n  pendingProjectUpdates: projectTql(first: 50, workspaceUuid: $workspaceUUID, q: $pendingUpdateProjectsTqlQuery, sort: [LATEST_UPDATE_DATE_ASC, NAME_ASC]) @include(if: $loadWritingModeProjectsQuery) {\n    edges {\n      node {\n        latestUserUpdate {\n          creationDate\n          id\n        }\n        id\n      }\n    }\n  }\n  pendingGoalUpdates: goalTql(first: 50, workspaceUuid: $workspaceUUID, q: $pendingUpdateGoalsTqlQuery, sorts: [LATEST_UPDATE_DATE_ASC, NAME_ASC]) @include(if: $loadWritingModeGoalsQuery) {\n    edges {\n      node {\n        latestUserUpdate {\n          creationDate\n          id\n        }\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "9f8a4fcc72ac3e0965fa4b94bc3acc3e";

export default node;
